<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Documentos Cadastrados'">
          <template v-slot:preview>
            <div col-md-2 col-lg-2>
              <v-btn
                color="success"
                v-if="
                  verificarPermissaoGrupoDocumento(permissoesPadrao.Incluir)
                "
                small
                dark
                @click="novoGrupo"
                class="mr-2"
                ><v-icon small>mdi-plus</v-icon>&nbsp;&nbsp;Novo Grupo de
                Documentos</v-btn
              >
              <v-btn
                color="primary"
                v-if="verificarPermissao(permissoesPadrao.Incluir)"
                small
                dark
                @click="novoDocumento"
                ><v-icon small>mdi-plus</v-icon>&nbsp;&nbsp;Novo
                Documento</v-btn
              >
            </div>
            <div v-if="habilitaFormularioGrupo">
              <hr />
              <form @submit.stop.prevent="salvarGrupo">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model.trim="grupo.nome"
                      label="Digite o Nome do Grupo"
                      clearable
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-btn
                      title="Salvar"
                      type="submit"
                      fab
                      small
                      color="primary"
                      class="mt-2"
                      ><v-icon small>fas fa-save</v-icon></v-btn
                    >
                    <v-btn
                      title="Cancelar"
                      type="button"
                      fab
                      small
                      color="error"
                      class="mt-2 ml-2"
                      @click="cancelar"
                      ><v-icon small>fas fa-times</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </form>
            </div>
            <br />
            <v-expansion-panels>
              <v-expansion-panel v-for="grupo in grupos" :key="grupo.id">
                <v-expansion-panel-header>
                  <v-row>
                    <v-col cols="11">
                      {{ grupo.nome }}
                    </v-col>
                    <v-col>
                      <!-- <v-btn
                        v-if="verificarPermissaoAprovador()"
                        title="Aprovadores"
                        type="button"
                        icon
                        x-small
                        color="primary"
                        class="mr-2"
                        @click="openDialog(grupo.id)"
                        ><v-icon small>fas fa-user</v-icon></v-btn
                      > -->
                      <v-btn
                        v-if="
                          verificarPermissaoGrupoDocumento(
                            permissoesPadrao.Editar
                          )
                        "
                        title="Editar"
                        type="button"
                        icon
                        x-small
                        color="warning"
                        class="mr-2"
                        @click="editarGrupo(grupo.id)"
                        ><v-icon small>fas fa-edit</v-icon></v-btn
                      >
                      <v-btn
                        title="Excluir"
                        type="button"
                        icon
                        x-small
                        color="error"
                        v-if="
                          grupo.documentos.length === 0 &&
                          verificarPermissaoGrupoDocumento(
                            permissoesPadrao.Excluir
                          )
                        "
                        @click="inativarGrupo(grupo.id)"
                        ><v-icon small>fas fa-trash</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-alert
                    dense
                    outlined
                    type="info"
                    v-if="grupo.documentos.length === 0"
                  >
                    Sem Documentos Vinculados à esse Grupo de Documentos
                  </v-alert>
                  <div v-else>
                    <v-row>
                      <v-col cols="6" offset="6">
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Pesquisa"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-data-table
                      :headers="headers"
                      :items="grupo.documentos"
                      :search="search"
                      :items-per-page.sync="grupo.itemsPerPage"
                      :page.sync="grupo.page"
                    >
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>{{ item.id }}</td>
                          <td>{{ item.nome }}</td>
                          <td>{{ item.criticidadeNome }}</td>
                          <td>{{ item.bloqueiaPagamento ? "SIM" : "NÃO" }}</td>
                          <td>{{ item.tipoDocumentoNome }}</td>
                          <td>
                            {{
                              item.tipoDocumentoID === 1
                                ? item.periodocidade
                                : ""
                            }}
                          </td>
                          <td>{{ item.obrigatorio ? "SIM" : "NÃO" }}</td>
                          <td style="min-width: 150px" align="center">
                            <v-btn
                              color="warning"
                              v-if="verificarPermissao(permissoesPadrao.Editar)"
                              fab
                              x-small
                              dark
                              @click="editar(item.id)"
                              ><v-icon>mdi-pencil</v-icon></v-btn
                            >
                            <v-btn
                              v-if="
                                verificarPermissao(permissoesPadrao.Excluir)
                              "
                              color="error"
                              fab
                              x-small
                              dark
                              @click="inativar(item.id)"
                              class="ml-2"
                              ><v-icon>mdi-trash-can</v-icon></v-btn
                            >
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <GrupoDocumentoUsuarioDialog
      :dialog="dialog"
      :grupoDocumentoUsuario="grupoDocumentoUsuario"
      @sync-dialog="grupoDocumentoUsuarioDialogSync"
    ></GrupoDocumentoUsuarioDialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import GrupoDocumentoUsuarioDialog from "./grupoDocumentoUsuario/GrupoDocumentoUsuarioDialog.vue";
import GrupoDocumentoUsuarioService from "@/common/services/http/grupoDocumentoUsuario.service";
import UsuarioService from "@/common/services/http/usuario.service";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import { SET_LOADING } from "@/store/config.module";

export default {
  name: "documento",
  data() {
    return {
      grupos: [],
      search: "",
      dialog: false,
      permissoesPadrao: {},
      grupoDocumentoUsuario: {
        itemSelecionados: [],
        usuarios: [],
        grupoDocumentoID: 0,
      },
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "nome" },
        { text: "Criticidade", value: "criticidadeNome" },
        { text: "Bloqueia Pagamento?", value: "bloqueiaPagamento" },
        { text: "Tipo de Documento", value: "tipoDocumentoNome" },
        { text: "Periodicidade (em meses)", value: "periodocidade" },
        { text: "Obrigatório?", value: "obrigatorio" },
        { text: "", value: "" },
      ],
      cliente: {},
      grupo: {
        id: 0,
        nome: "",
        clienteID: 0,
      },
      habilitaFormularioGrupo: false,
    };
  },
  components: {
    KTCodePreview,
    GrupoDocumentoUsuarioDialog,
  },
  methods: {
    async openDialog(grupoDocumentoID) {
      this.grupoDocumentoUsuario.grupoDocumentoID = grupoDocumentoID;
      let grupoDocumentoUsuarios =
        await GrupoDocumentoUsuarioService.getGrupoDocumentoUsuarioByGrupoDocumentoID(
          grupoDocumentoID
        );

      this.grupoDocumentoUsuario.itemSelecionados =
        grupoDocumentoUsuarios.success
          ? grupoDocumentoUsuarios.data.map((x) => x.usuarioID)
          : [];

      let usuarios = await UsuarioService.getUsuarios(this.cliente.id);

      this.grupoDocumentoUsuario.usuarios = usuarios.success
        ? usuarios.data.filter((x) => x.tipoUsuario == 3)
        : [];

      this.dialog = true;
    },

    grupoDocumentoUsuarioDialogSync(obj) {
      this.dialog = obj.dialog;
    },

    novoDocumento() {
      this.popularPaginacaoDocumentos();
      this.$router.push({ name: "documentoCadastro" });
    },

    novoGrupo() {
      this.habilitaFormularioGrupo = true;
    },

    cancelar() {
      this.habilitaFormularioGrupo = false;
    },

    popularPaginacaoDocumentos() {
      const tabelaDocumentos = [];

      const grupos = this.grupos.filter((g) => g.page > 1);

      for (let i = 0; i < grupos.length; i++) {
        const grupo = grupos[i];

        tabelaDocumentos.push({
          grupoID: grupo.id,
          page: grupo.page,
          itemsPerPage: grupo.itemsPerPage,
        });
      }

      sessionStorage.setItem(
        "tabelaDocumentos",
        JSON.stringify(tabelaDocumentos)
      );
    },

    async listaGrupos() {
      const { data: result } = await ApiService.get(
        "grupodocumento/getbyclienteid/" + this.cliente.id
      );

      if (result.success) {
        const tabelaDocumentos = sessionStorage.getItem("tabelaDocumentos")
          ? JSON.parse(sessionStorage.getItem("tabelaDocumentos"))
          : null;

        for (let i = 0; i < result.data.length; i++) {
          const grupo = result.data[i];
          grupo.page = 1;
          grupo.itemsPerPage = 10;

          if (tabelaDocumentos) {
            const tabelaGrupo = tabelaDocumentos.find(
              (td) => td.grupoID == grupo.id
            );
            if (tabelaGrupo) {
              grupo.itemsPerPage = tabelaGrupo.itemsPerPage;
              grupo.page = tabelaGrupo.page;
            }
          }
        }

        sessionStorage.removeItem("tabelaDocumentos");
        this.grupos = result.data;
      } else SweetAlert.sweetAlertError(result.errors);

      this.$store.commit(SET_LOADING, false);
    },

    editar(id) {
      this.popularPaginacaoDocumentos();
      this.$router.push({ path: "documento/cadastro/" + id });
    },

    inativar(id) {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("documento/" + id + "/inativar").then(({ data }) => {
              if (data.success) {
                resolve(data);

                if (data.success === true) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Documento Inativado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.popularPaginacaoDocumentos();
                    self.listaGrupos();
                  });
                }
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },

    salvarGrupo() {
      let self = this;

      if (this.grupo.id === 0) {
        return new Promise((resolve) => {
          ApiService.post("grupodocumento", this.grupo).then(({ data }) => {
            if (data.success) {
              resolve(data);

              Swal.fire({
                position: "center",
                icon: "success",
                title: "Grupo de Documentos Cadastrado com Sucesso!",
                showConfirmButton: false,
                timer: 1500,
              }).then(function () {
                self.popularPaginacaoDocumentos();
                self.listaGrupos();

                self.grupo.id = 0;
                self.grupo.nome = "";

                self.habilitaFormularioGrupo = false;
              });
            } else SweetAlert.sweetAlertError(data.errors);
          });
        });
      } else {
        return new Promise((resolve) => {
          ApiService.put("grupodocumento/" + this.grupo.id, this.grupo).then(
            ({ data }) => {
              if (data.success) {
                resolve(data);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Grupo de Documentos Alterado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.popularPaginacaoDocumentos();
                  self.listaGrupos();

                  self.grupo.id = 0;
                  self.grupo.nome = "";

                  self.habilitaFormularioGrupo = false;
                });
              } else SweetAlert.sweetAlertError(data.errors);
            }
          );
        });
      }
    },

    editarGrupo(id) {
      return new Promise((resolve) => {
        ApiService.get("grupodocumento/" + id).then(({ data }) => {
          if (data.success) {
            resolve(data);

            this.grupo = data.data;
            this.habilitaFormularioGrupo = true;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Documento, permissao);
    },

    verificarPermissaoAprovador() {
      return (
        PermissoesService.verificarAcesso(
          Modulo.Aprovadores,
          this.permissoesPadrao.Incluir
        ) ||
        PermissoesService.verificarAcesso(
          Modulo.Aprovadores,
          this.permissoesPadrao.Excluir
        )
      );
    },

    verificarPermissaoGrupoDocumento(permissao) {
      return PermissoesService.verificarAcesso(
        Modulo.GrupoDocumento,
        permissao
      );
    },

    inativarGrupo(id) {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse grupo?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("grupodocumento/" + id + "/inativar").then(
              ({ data }) => {
                resolve(data);

                if (data.success === true) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Grupo de Documentos Inativado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.popularPaginacaoDocumentos();
                    self.listaGrupos();
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          });
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Documentos" }]);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.grupo.clienteID = this.cliente.id;
    this.listaGrupos();
    this.permissoesPadrao = Permissoes;
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(
        Modulo.Documento,
        Permissoes.Visualizar
      )
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
